import { CanDeactivateFn } from '@angular/router';
import { DefectDetailComponent } from './defect-detail.component';

export const canDeactivateDefectDetail: CanDeactivateFn<DefectDetailComponent> = (component) => {
  if (component.hasUnsavedChanges()) {
    return component.confirmDeactivate();
  }
  return true;
};
